const transcriptData = [
    [
        {}
    ],
    [
        {
            id: 0,
            name: "larryPartOne",
            source: "./files/transcripts/partOneTranscript.pdf"
        }
    ],
    [
        {
            id: 0,
            name: "larryPartTwo",
            source: "./files/transcripts/partTwoTranscript.pdf"
        }
    ],
    [
        {
            id: 0,
            name: "larryPartThree",
            source: "./files/transcripts/partThreeTranscript.pdf"
        }
    ],
    [
        {
            id: 0,
            name: "larryPartFour",
            source: "./files/transcripts/partFourTranscript.pdf"
        },
        {
            id: 1,
            name: "speakToJackAudio",
            source: "./files/transcripts/jackTranscript.pdf"
        },
    ],
    [
        {
            id: 0,
            name: "larryPartFive",
            source: "./files/transcripts/partFiveTranscript.pdf"
        }
    ],
]

export default transcriptData